// 引导插件
;(function() {
    "use strict"
    let _global;
    const CircularLoad = function () {
        this.option = {
            appendTo: '',
            width: 100,
            height: 100,
            progress: 0, // 0-100/auto/{auto: true, max: 100}
            line: 4, // { width, color, round: true }
            text: '', // Opening Document {progress}%/{fontSize,fontFamily,color,content}
            zIndex: 100,
            mask: true // #ABABAB/rgba(0,0,0,0.2)
        };
    }
    const querySelector = function (selector) {
        if (!selector) return document.body;
        if (typeof selector === 'string') return document.querySelector(selector);
        return selector;
    }
    const getComputedStyle = function (dom, cssAttr) {
        let ret;
        if (window.currentStyle) {
            ret = window.currentStyle(dom).getAttribute(cssAttr);
        } else {
            ret = (window || document.defaultView).getComputedStyle(dom).getPropertyValue(cssAttr);
        }
        return ret;
    }
    // 创建遮罩层
    const createMask = function (zIndex, mask) {
        if (zIndex === undefined) zIndex = 100;
        if (typeof mask === 'boolean') mask = 'rgba(0, 0, 0, 0.2)';
        var $mask = document.createElement('div');
        $mask.style = 'position: absolute;top: 0;left: 0;width: 100%;height: 100%;background-color: ' + mask + ';z-index: ' + zIndex + ';';
        return $mask;
    }
    // 创建圆形canvas
    const createCanvas = function (width, height, zIndex) {
        var $canvas = document.createElement('canvas');
        $canvas.width = width;
        $canvas.height = height;
        $canvas.style = 'position: absolute;top: 0;left: 0;right: 0;bottom: 0;margin: auto;z-index: ' + zIndex + ';';
        return $canvas;
    }
    // 绘制canvas
    const drawCanvas = function (canvas, width, line, progress, text, onProgressFinish) {
        var lineWidth = line.width || line;
        var lineColor = line.color || '#49f';
        var lineRound = line.round;
        var context = canvas.getContext('2d');
        var centerX = canvas.width / 2;
        var rad = Math.PI * 2 / 100;
        var r = width / 2 - lineWidth / 2;
        var blueCircle = function (n) { 
            context.beginPath(); 
            context.strokeStyle = lineColor; 
            context.lineWidth = lineWidth; 
            context.lineCap = lineRound ? 'round' : '';
            context.arc(centerX, width / 2, r, -Math.PI / 2, -Math.PI / 2 + n * rad, false); 
            context.stroke(); 
        } 
        var whiteCircle = function () { 
            context.beginPath(); 
            context.strokeStyle = "#ffffff"; 
            context.lineWidth = lineWidth; 
            context.arc(centerX, width / 2, r, 0, Math.PI * 2, false); 
            context.stroke(); 
            context.closePath(); 
        } 
        var setText = function (text) { 
            var fontSize = text.fontSize || 12;
            var fontFamily = text.fontFamily || 'Alatsi';
            var color = text.color || '#FFFFFF';
            var content = text.content || text || '';
            content = content.replace('{progress}', progress);
            context.fillStyle = color; 
            context.font = fontSize + "px " + fontFamily; 
            context.textAlign = "center"; 
            context.textBaseline = "middle"; 
            var space = 6;
            var textHeight = fontSize + space;
            var textes = content.split('\n').reverse();
            var isTextBottom = ((canvas.height - width) > (fontSize + space));
            for (let index = 0; index < textes.length; index++) {
                context.fillText(textes[index], centerX, isTextBottom ? (canvas.height - fontSize - textHeight * index) : (width / 2));
            }
            context.restore(); 
        }
        progress = Math.min(progress, 100);
        context.clearRect(0, 0, canvas.width, canvas.height); 
        whiteCircle();
        blueCircle(progress);
        setText(text);
        if (progress === 100) {
            setTimeout(onProgressFinish, 200);
        }
    }
    // 随机数
    const randomNum = function (minNum, maxNum) { 
        switch (arguments.length) { 
            case 1: 
                return parseInt(Math.random() * minNum + 1, 10); 
            case 2: 
                return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
            default: 
                return 0; 
        } 
    }
    CircularLoad.getInstance = function() {
        if (this.instance) {
            return this.instance;
        }
        return this.instance = new CircularLoad();
    }
    // 显示CircularLoad
    CircularLoad.prototype.show = function (option) {
        if (option) Object.assign(this.option, option);
        option = this.option;
        var $appendTo = querySelector(option.appendTo);
        // 创建遮罩层
        if (option.mask && !this.$mask) {
            this.$mask = createMask(option.zIndex - 1, option.mask);
            $appendTo.appendChild(this.$mask);
        }
        if (!option.mask && this.$mask) {
            this.$mask.remove();
        }
        // 创建圆形canvas
        var $canvas = this.$canvas;
        if (!$canvas) {
            $canvas = createCanvas(option.width * 2, option.height, option.zIndex);
            $appendTo.appendChild($canvas);
            this.$canvas = $canvas;
            this._appendToOverflow = getComputedStyle($appendTo, 'overflow');
            $appendTo.style.overflow = 'hidden';
        }
        // canvas上画进度
        var timer = this._timer;
        if (!isNaN(option.progress)) {
            timer && clearInterval(timer);
            drawCanvas($canvas, option.width, option.line, option.progress, option.text, this.finishCallback);
        } else if (!timer && (option.progress === 'auto' || option.progress.auto)) {
            var progress = randomNum(0, 5);
            var maxProgress = option.progress.max || 100;
            var _this = this;
            timer = this._timer = setInterval(function () {
                progress = randomNum(progress, Math.min(progress + 5, maxProgress));
                drawCanvas($canvas, option.width, option.line, progress, option.text, function () {
                    clearInterval(timer);
                    _this.finishCallback();
                });
            }, randomNum(1.5, 2) * 200);
            drawCanvas($canvas, option.width, option.line, progress, option.text);
        }
        return this;
    }
    // 隐藏CircularLoad
    CircularLoad.prototype.hide = function () {
        if (this.$mask) {
            this.$mask.remove();
        }
        if (this.$canvas) {
            var $parentNode = this.$canvas.parentNode;
            if ($parentNode) $parentNode.style.overflow = this._appendToOverflow;
            this.$canvas.remove();
        }
    }
    // 进度100%
    CircularLoad.prototype.onFinish = function (callback) {
        this.finishCallback = callback.bind(this);
        return this;
    }

    const plugin = {
        show: function (option) {
            if (!this.cache) this.cache = [];
            var circularLoad;
            for (var index = 0; index < this.cache.length; index++) {
                var _circularLoad = this.cache[index];
                if (_circularLoad.option.appendTo === option.appendTo) {
                    circularLoad = _circularLoad;
                    break;
                }
            }
            if (!circularLoad) {
                circularLoad = new CircularLoad();
                this.cache.push(circularLoad);
            }
            return circularLoad.show(option);
        }
    };

    _global = (function(){ return this || (0, eval)('this'); }());
    if (typeof module !== "undefined" && module.exports) {
        module.exports = plugin;
    } else if (typeof define === "function" && define.amd) {
        define(function(){return plugin;});
    } else {
        !('plugin' in _global) && (_global.circularLoad = plugin);
    }
}());